import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import sessionStorage from "redux-persist/lib/storage/session";
import { encryptTransform } from "redux-persist-transform-encrypt";
import reducers from "./reducers";

const persistConfig = {
  key: "quizzr-test-platform",
  storage: sessionStorage,
  whitelist: ["counter", "user", "timer", "global"],
  transforms: [encryptTransform({ secretKey: import.meta.env.VITE_PERSIST_KEY })],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: import.meta.env.MODE !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE", "persist/REGISTER"],
      },
    }),
});

export default store;
